import { Box, CloseButton, Drawer } from "@mantine/core";
import { FC, useEffect, useState } from "react";
import { ContextModalProps, modals } from "@mantine/modals";
import LeadSteps from "./LeadSteps";
import { useDisclosure } from "@mantine/hooks";
import { openPractitionerListDrawer } from "components/PractitionerListDrawer";

interface Props {
  practitionerInfo: any;
  onClose?: (v?: boolean) => void;
  initialSearchValue?: string;
  hideHeader?: boolean;
  editMode?: boolean;
}

const LeadDrawer: FC<ContextModalProps<Props>> = ({
  context, id, innerProps
}) => {
  const [isOnFormView, setIsOnFormView] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);
  const [opened, {open, close }] = useDisclosure(false);

  useEffect(() => {
    open();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Drawer
      opened={opened}
      zIndex={5001}
      size="calc(100vh - 20px)"
      p={0}
      radius="30px 30px 0 0"
      onClose={() => {
        if (innerProps?.onClose) {
          innerProps?.onClose(false);
        }
        close();
        context.closeModal(id);
      }}
      position="bottom"
      variant={!isOnFormView ? "baseball-card" : (
        !isFormValid
          ? "baseball-card--red"
          : "baseball-card--green"
        )}
      styles={{
        header: {
          display: "none"
        },
        body: {
          height: "100%",
          boxSizing: "border-box"
        }
      }}
    >
      {isOnFormView && (
        <Box
          bg={isFormValid ? "#00DC49" : "#E64B37"}
          display="block"
          w="100%"
          pos="absolute"
          top={0}
          left={0}
          lh="25px"
          ta="center"
          c="white">
          {isFormValid ? 
            "Not in Netsuite: Ready to Submit" : "Not in Netsuite: Incomplete Lead"}
        </Box>
      )}
      <Box
        p={0}
        pt={40}
        w="100%"
        h="100%"
        pos="relative"
        style={{
          boxSizing: "border-box"
        }}>
       {!innerProps?.hideHeader && isOnFormView && ( 
        <>
          <Box
            c="#4F7D9C"
            fz="h4"
            fw="bold"
            pos="absolute"
            top={40}
            left={10}>
            {innerProps?.editMode ? "Edit Lead" : "Create New Lead"}
          </Box>
          <CloseButton
            size="xl"
            pos="absolute"
            top={25}
            right={-10}
            style={{
              zIndex: 5002,
            }}
            onClick={() => {
              if (innerProps?.onClose) {
                innerProps?.onClose(false);
              }
              context.closeModal(id);
            }} />
          <Box pos="absolute" top={75}
            style={{
              borderTop: "1px solid #8B8B8B",
              width: "100%",
            }}>
          </Box>
        </>
        )}
        <Box pt={!innerProps?.hideHeader && isOnFormView ? 55 : 5} 
          style={{
            position: "relative",
            boxSizing: "border-box",
            overflowY: "hidden",
            height: "100%",
          }}>
          <LeadSteps
            initialSearchValue={innerProps?.initialSearchValue || ""}
            practitionerInfo={innerProps?.practitionerInfo}
            onFormStateChange={(s) => setIsFormValid(s)}
            onFormViewChange={(v) => setIsOnFormView(v)}
            onViewDuplicate={() => {
              openPractitionerListDrawer({ noBackNav: true });
            }}
            onClose={(v) => {
              if (innerProps?.onClose) {
                innerProps?.onClose(v);
              }
              close();
              context.closeModal(id);
            }} />
        </Box>
      </Box>
    </Drawer>
  );
};

export const openLeadDrawer = (
  practitionerInfo: any,
  opts: {
    initialSearchValue?: string,
    hideHeader?: boolean,
    editMode?: boolean,
  },
  onClose?: (v?: boolean) => void,
): string => {
  return modals.openContextModal({
    modal: "leadDrawer",
    innerProps: {
      practitionerInfo: practitionerInfo,
      initialSearchValue: opts?.initialSearchValue,
      onClose: onClose,
      hideHeader: opts?.hideHeader,
      editMode: opts?.editMode
    },
    withOverlay: false,
    withCloseButton: false,
    variant: "baseball-card",
  });
};

export default LeadDrawer;